'use client';

/**
 * The "Standard version" control at the foot of an Easy Read page.
 *
 * IT USED TO DO NOTHING. When the shell swaps a page for its Easy Read version, the Easy Read page
 * is shown at the page's own address, and this control was a <Link href={pathname}> — it navigated
 * to the address you were already on while the Easy Read preference stayed on (it is remembered in
 * localStorage), so the Easy Read version simply rendered again. A visitor who turned Easy Read on
 * had no way back from this page, on every page, and the preference followed them around the site.
 * Found 20 Oct 2026 from Annette's "The Easy Ready button up the top is not working consistently".
 *
 * There are two honest behaviours, so the caller says which:
 *   no href  - this is the standard page shown in Easy Read, so turn the preference off and stay.
 *   an href  - Easy Read is its OWN address here (/privacy/easy-read), so go to the standard one.
 */

import Link from 'next/link';
import { easyRead } from './easyReadStore';

const CLASS =
  'inline-flex min-h-touch items-center rounded-control border-2 border-ink bg-surface px-[22px] py-[14px] text-body font-bold text-ink no-underline';

export function StandardVersionControl({ href }: { href?: string }) {
  if (href) {
    return (
      <Link href={href} className={CLASS}>
        Standard version
      </Link>
    );
  }
  return (
    <button type="button" onClick={() => easyRead.set(false)} className={CLASS}>
      Standard version
    </button>
  );
}
